import { defineMessages } from 'react-intl';

const translations = {
  bulkActions: {
    putaway: {
      id: 'pages.putaway.bulkActions.putaway',
      defaultMessage: 'Put away',
      description: 'Label of the put away bulk action on the putaway page',
    },
  },
  progressDialog: {
    isPuttingAway: {
      id: 'pages.putaway.progressDialog.isPuttingAway',
      defaultMessage: 'Putting away items',
      description: 'Message of the putting away items progress dialog on the putaway page',
    },
  },
  confirmOverageDialog: {
    title: {
      id: 'pages.putaway.confirmOverageDialog.title',
      defaultMessage: 'Confirm overage',
      description: 'Title of the confirm overage dialog',
    },
    description: {
      id: 'pages.putaway.confirmOverageDialog.description',
      defaultMessage:
        'You have placed more items than requested. Are you sure you have not placed too many items?',
      description: 'Description of the confirm overage dialog',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel button of the confirm overage dialog',
      },
      save: {
        id: 'actions.save',
        defaultMessage: 'Save',
        description: 'Label of the save button of the confirm overage dialog',
      },
    },
  },
  itemQuantityDialog: {
    title: {
      id: 'pages.putaway.itemQuantityDialog.title',
      defaultMessage: 'Put away product',
      description: 'Title of the item quantity dialog on the putaway page',
    },
    quantityCounter: {
      received: {
        id: 'pages.putaway.itemQuantityDialog.quantityCounter.received',
        defaultMessage: 'Received',
        description: 'Label of the quantity counter requested field',
      },
      putaway: {
        id: 'pages.putaway.itemQuantityDialog.quantityCounter.putaway',
        defaultMessage: 'Put away',
        description: 'Label of the quantity counter put away field',
      },
    },
  },
  positionDialog: {
    title: {
      id: 'pages.putaway.positionDialog.title',
      defaultMessage: 'Position',
      description: 'Title of the position dialog',
    },
  },
  remainingItemsDialog: {
    title: {
      id: 'pages.putaway.remainingItemsDialog.title',
      defaultMessage: 'Remaining items',
      description: 'Title of the remaining items dialog',
    },
    description: {
      id: 'pages.putaway.remainingItemsDialog.description',
      defaultMessage: 'There are still items remaining to be put away. Want to finish anyway?',
      description: 'Description of the remaining items dialog',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel button of the remaining items dialog',
      },
      forceFinish: {
        id: 'actions.finish',
        defaultMessage: 'Finish',
        description: 'Label of the finish button of the remaining items dialog',
      },
    },
  },
  unknownItemDialog: {
    title: {
      id: 'pages.putaway.unknownItemDialog.title',
      defaultMessage: 'Unknown item',
      description: 'Title of the unknown item dialog',
    },
    description: {
      id: 'pages.putaway.unknownItemDialog.description',
      defaultMessage:
        'The product you have scanned is not on this list. Would you like to add this product as overage product on the shipment?',
      description: 'description of the unknown item dialog',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'label of the cancel button',
      },
      add: {
        id: 'actions.add',
        defaultMessage: 'Add',
        description: 'label of the add button',
      },
    },
  },
  feedback: {
    itemsNotPutaway: {
      id: 'pages.putaway.feedback.itemsNotPutaway',
      defaultMessage: 'Items could not be put away on position',
      description: 'Error message of the put away items on position action',
    },
    multipleItemsPutaway: {
      id: 'pages.putaway.feedback.multipleItemsPutaway',
      defaultMessage: 'Items put away',
      description: 'Success message of the put away multiple products action',
    },
    multipleItemsNotPutaway: {
      id: 'pages.putaway.feedback.multipleItemsNotPutaway',
      defaultMessage: 'Items could not be put away',
      description: 'Error message of the put away multiple products action',
    },
    putawayNotFinished: {
      id: 'pages.putaway.feedback.putawayNotFinished',
      defaultMessage: 'Handling list could not be finished',
      description: 'Error message of the finish put away action',
    },
    unknownPosition: {
      id: 'pages.putaway.feedback.unknownPosition',
      defaultMessage: 'Unknown position',
      description: 'Error message for entering an unknown position',
    },
  },
};

export default defineMessages(translations);
